;
(function (ng) {
  'use strict';

  angular.module('harmonica', ['dom']);
})(angular);